import React, { useEffect, useRef, useState } from 'react';

import Pagination from 'rc-pagination';
import _en_US from 'rc-pagination/lib/locale/en_US';

import AppActions from '../../actions/app-actions';
import Loader from '../common/loader';
import DeviceHistoryList from './device-history-list';
import { showError } from '../../helpers';

const DeviceHistory = () => {
  const [state, setState] = useState({ count: 0, pageNo: 1, pageLength: 20, devices: [], pageLoading: false });
  const [loading, setLoading] = useState(true);
  const mountRef = useRef(null);

  const getHistoryData = (pageNo) => {
    Promise.all([
      AppActions.getDeviceHistoryCount(),
      AppActions. getDevicesHistory(pageNo, state.pageLength)
    ])
      .then(results => {
        const countResult = results[0] || [];
        const deviceResult = results[1] || [];
        let count = 0;
        const devices = [];
        if (Array.isArray(countResult.results)) {
          countResult.results.forEach(({series=[]}) => {
            series.forEach(({values=[]})=> {
              count += values.length;
            });
          });
        }

        if (Array.isArray(deviceResult.results)) {
          deviceResult.results.forEach(({series=[]}) => {
            series.forEach((data) => {
              devices.push({uuid: data.tags.uuid, time: data.values[0][0], status: data.values[0][1]});
            });
          });
        }

        setState(prev => ({ ...prev, pageNo, count, devices }));
      })
      .catch(err => {
        showError(err, `Device status history couldn't be loaded.`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    mountRef.current = true;
    getHistoryData(1);
    return () => {
      mountRef.current = false;
    };
  }, []);

  const handlePageChange = (pageNo) => {
    getHistoryData(pageNo);
  };

  const content = () => {
    if (loading) {
      return (
        <Loader show={true} />
      );
    } else {
      if (!state.devices.length) {
        return (
          <div className='dashboard-placeholder'>
            <p>There are no device history</p>
          </div>
        );
      } else {
        return (
          <div>
            <DeviceHistoryList devices={state.devices} />
            <Pagination 
              className="margin-top"
              locale={_en_US}
              simple
              pageSize={state.pageLength}
              current={state.pageNo}
              total={state.count}
              onChange={handlePageChange}              
            />
          </div>
        );
      }
    }
  };

  return (
    <div className='tab-container'>
      {content()}
    </div>
  );
};

export default DeviceHistory;
